import axios, { AxiosResponse } from "axios";
import { AuthorSampleTeach } from "../../models/dtos/content/AuthorSampleTeach";
import { ProductAuthorDTO } from "../../models/dtos/content/ProductAuthorDTO";
import { SampleTeachingDTO } from "../../models/dtos/content/SampleTeachingDTO";
import { QueryPagesDTO } from "../../models/query-strings/base/QueryPagesDTO";
import BaseService from "../base/BaseService";
import { AdvisoryTeamDTO } from "../../models/dtos/content/AdvisoryTeamDTO";

export default class ProductAuthorService extends BaseService {
    getSampleTeachesList(queryInfo: QueryPagesDTO): Promise<SampleTeachingDTO[]> {
        return axios.get(`/ProductAuthor/SampleTeach`, { params: queryInfo })
            .then(function (response: AxiosResponse<SampleTeachingDTO[], any>) {
                return response.data;
            });
    }

    getSampleTeachesByAuthorId(productAuthorId: number): Promise<AuthorSampleTeach> {
        return axios.get(`/ProductAuthor/AuthorTeaches/${productAuthorId}`)
            .then(function (response: AxiosResponse<AuthorSampleTeach, any>) {
                return response.data;
            });
    }

    getForemostAuthors(): Promise<ProductAuthorDTO[]> {
        return axios.get(`/ProductAuthor/ForemostAuthors`)
            .then(function (response: AxiosResponse<ProductAuthorDTO[]>) {
                return response.data;
            });
    }

    getAdvisoryTeam(): Promise<AdvisoryTeamDTO[]> {
        return axios.get(`/ProductAuthor/GetAdvisoryTeam`)
            .then(function (response: AxiosResponse<AdvisoryTeamDTO[]>) {
                return response.data;
            });
    }

    getAssistantDetailByUserId(assistantUserId: string): Promise<ProductAuthorDTO> {
        return axios.get(`/Assistant/AssistantResume/${assistantUserId}`)
            .then(function (response: AxiosResponse<ProductAuthorDTO>) {
                return response.data;
            });
    }

    getDetailByAuthorId(productAuthorId: number): Promise<ProductAuthorDTO> {
        return axios.get(`/ProductAuthor/AuthorDetail/${String(productAuthorId)}`)
            .then(function (response: AxiosResponse<ProductAuthorDTO>) {
                return response.data;
            });
    }
}